import { Check, CircleX, Info, X } from "lucide-react";
import { Toaster } from "sonner";

import { Spinner } from "./spinner";

type SonnerProps = React.ComponentProps<typeof Toaster>;

const Sonner = (props: SonnerProps) => (
  <Toaster
    closeButton
    icons={{
      close: <X className="af-size-5 af-opacity-50" />,
      error: <CircleX className="af-size-5 af-text-destructive" />,
      info: <Info className="af-size-5 af-text-foreground" />,
      success: <Check className="af-size-5 af-text-success-accent" />,
      loading: <Spinner className="af-size-5 af-text-muted-foreground" />,
    }}
    toastOptions={{
      classNames: {
        actionButton:
          "af-ml-4 af-px-4 af-py-2.5 af-text-sm af-text-nowrap af-text-primary",
        closeButton:
          "af-close-button af-absolute af-right-2 af-top-2 af-p-1 af-opacity-0 group-hover:af-opacity-100 group-focus-within:af-opacity-100",
        content: "af-w-[300px]",
        default: "af-border-border",
        description: "af-text-foreground af-text-sm",
        error: "af-border-destructive/50",
        icon: "af-mr-2",
        loader:
          "sonner-loader af-hidden data-[visible=true]:af-block data-[visible=true]:af-static data-[visible=true]:af-transform-none",
        success: "af-border-success-accent/50",
        title: "af-text-foreground af-text-sm af-font-semibold",
        toast:
          "af-rounded-md af-border af-px-5 af-py-4 af-flex af-shadow-lg af-bg-background af-group",
      },
      unstyled: true,
    }}
    {...props}
  />
);
Sonner.displayName = "Sonner";

export { toast, useSonner } from "sonner";
export { Sonner };
